export default __webpack_public_path__ + "static/media/zasto_nase_namirnice.27d81ff2.png";